import { customizeError, downloadFile, formatDate, generateBlob } from '@chilecompra/react-kit'
import { REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS } from '../../config/settings/environment'
import { CERTIFICATE_STATUSES } from '../../config/settings/constant'
import { makeActionCreator } from '../../config/store/utils'
import {
  getSellerEnrollmentCertificate,
  getSellerEnrollmentCertificatePdf,
  getTenderEnrollmentCertificate,
  getTenderEnrollmentCertificatePdf
} from '../../services/enrollmentCertificate'
import { getSellerFilePDFPrivate, getSellerFilePDFPublic } from '../../services/openData'

export const GET_ENROLLMENT_CERTIFICATE = 'GET_ENROLLMENT_CERTIFICATE'
export const GET_ENROLLMENT_CERTIFICATE_ERROR = 'GET_ENROLLMENT_CERTIFICATE_ERROR'
export const GET_ENROLLMENT_CERTIFICATE_SUCCESS = 'GET_ENROLLMENT_CERTIFICATE_SUCCESS'
export const onGetEnrollmentCertificate = makeActionCreator(GET_ENROLLMENT_CERTIFICATE)
export const onGetEnrollmentCertificateError = makeActionCreator(GET_ENROLLMENT_CERTIFICATE_ERROR, 'payload')
export const onGetEnrollmentCertificateSuccess = makeActionCreator(GET_ENROLLMENT_CERTIFICATE_SUCCESS, 'payload')

export const onGetTenderEnrollmentCertificateThunk = payload => async dispatch => {
  dispatch(onGetEnrollmentCertificate())

  try {
    const { data } = await getTenderEnrollmentCertificate({
      actionType: GET_ENROLLMENT_CERTIFICATE,
      numAcquisition: payload.numAcquisition
    })

    if (REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS === true || REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS === 'true') {
      const certificateData = {
        certificate: {
          awardDate: data?.payload?.fechaAdjudicacion && formatDate(data?.payload?.fechaAdjudicacion),
          openingDate: data?.payload?.fechaApertura && formatDate(data?.payload?.fechaApertura),
          completed: true,
          folioNumber: data?.payload?.numeroFolio,
          currentDate: formatDate(data?.payload?.fechaConsulta),
          // Case to show the individual certificate
          temporaryUnions: data?.payload?.provUTP?.map(UTP => {
            return {
              idUTP: UTP.idUTP,
              providers: UTP.proveedores.map(provider => {
                return {
                  orgLegalName: provider.razonSocial,
                  dni: provider.rut,
                  status: provider.estado
                }
              }),
              status: UTP.estado || 'SIN INFORMACIÓN'
            }
          }),

          sellers: data?.payload?.provIndividuales?.map(seller => {
            return {
              dni: seller.rut,
              orgLegalName: seller.razonSocial,
              ability: {
                status: seller.estado || 'SIN INFORMACIÓN'
              }
            }
          }),
          // Case to show the group certificate from a tender
          opening: {
            temporaryUnions:
              data?.payload?.proveedoresEnApertura?.utp?.map(UTP => ({
                idUTP: UTP.idUTP,
                providers:
                  UTP.proveedores?.map(provider => ({
                    orgLegalName: provider.razonSocial,
                    dni: provider.rut,
                    status: provider.estado || 'SIN INFORMACIÓN'
                  })) || [],
                status: UTP.estado || 'SIN INFORMACIÓN'
              })) || [],

            sellers:
              data?.payload?.proveedoresEnApertura?.individuales?.map(seller => ({
                dni: seller.rut,
                orgLegalName: seller.razonSocial,
                ability: {
                  status: seller.estado || 'SIN INFORMACIÓN'
                }
              })) || []
          },

          adjudication: {
            temporaryUnions:
              data?.payload?.proveedoresEnAdjudicacion?.utp?.map(UTP => ({
                idUTP: UTP.idUTP,
                providers:
                  UTP.proveedores?.map(provider => ({
                    orgLegalName: provider.razonSocial,
                    dni: provider.rut,
                    status: provider.estado || 'SIN INFORMACIÓN'
                  })) || [],
                status: UTP.estado || 'SIN INFORMACIÓN'
              })) || [],

            sellers:
              data?.payload?.proveedoresEnAdjudicacion?.individuales?.map(seller => ({
                dni: seller.rut,
                orgLegalName: seller.razonSocial,
                ability: {
                  status: seller.estado || 'SIN INFORMACIÓN'
                }
              })) || []
          },

          tenderID: data?.payload?.idLicitacion
        }
      }
      return dispatch(onGetEnrollmentCertificateSuccess(certificateData))
    }

    return dispatch(
      onGetEnrollmentCertificateSuccess({
        certificate: {
          awardDate: data?.payload?.fechaAdjudicacion && formatDate(data?.payload?.fechaAdjudicacion),
          openingDate: data?.payload?.fechaApertura && formatDate(data?.payload?.fechaApertura),
          folioNumber: data?.payload?.numeroFolio,
          completed:
            CERTIFICATE_STATUSES[data?.payload?.estado] === 'TERMINADO OK' ||
            CERTIFICATE_STATUSES[data?.payload?.estado] === 'TERMINADO NOK',
          currentDate: data?.payload?.fechaConsulta,
          failed: CERTIFICATE_STATUSES[data?.payload?.estado] === 'TERMINADO NOK',
          sellers: data?.payload?.proveedoresAdjudicados.map(seller => {
            return {
              dni: seller.rutProveedor.toUpperCase(),
              orgLegalName: seller.razonSocial,
              ability: {
                status: seller.estadoHabilidad || 'SIN INFORMACIÓN',
                detail: seller.detalleHabilidad,
                observations: seller.observaciones
              }
            }
          }),
          tenderID: data?.payload?.codigoExterno
        }
      })
    )
  } catch (error) {
    if (error.originalError?.code === 'ERR_CANCELED') return

    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetEnrollmentCertificateError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}

export const onGetSellerEnrollmentCertificateThunk = payload => async (dispatch, getState) => {
  dispatch(onGetEnrollmentCertificate())

  try {
    const { sellerCertificates } = getState().enrollmentCertificate
    const { data } = await getSellerEnrollmentCertificate({
      dni: payload.dni ? payload.dni : undefined,
      actionType: GET_ENROLLMENT_CERTIFICATE
    })

    const abilityList = data?.payload?.detalleHabilidad.map(item => item.replace(/ï¿½/g, 'ó'))

    const certificate = {
      completed: true,
      currentDate: data?.payload?.fechaConsulta,
      disabilityReasons: data?.payload?.estadoHabilidad === 'INHABIL' ? abilityList : [],
      failed: false,
      folioNumber: data?.payload?.numeroFolio,
      isForeign: data?.payload?.esExtranjero,
      sellers: [
        {
          dni: data?.payload?.rutProveedor.toUpperCase(),
          orgLegalName: data?.payload?.razonSocial,
          ability: {
            status: data?.payload?.estadoHabilidad || 'SIN INFORMACIÓN',
            detail: data?.payload?.detalleHabilidad,
            observations: data?.payload?.observaciones
          },
          typeSeller: data?.payload?.tipoProveedor,
          isForeign: data?.payload?.esExtranjero
        }
      ]
    }

    if (sellerCertificates[data?.payload?.rutProveedor.toUpperCase()]) {
      sellerCertificates[data?.payload?.rutProveedor.toUpperCase()] = certificate
      return dispatch(
        onGetEnrollmentCertificateSuccess({
          certificate,
          sellerCertificates
        })
      )
    }

    return dispatch(
      onGetEnrollmentCertificateSuccess({
        certificate,
        sellerCertificates: {
          ...sellerCertificates,
          [data?.payload?.rutProveedor.toUpperCase()]: certificate
        }
      })
    )
  } catch (error) {
    if (error.originalError?.code === 'ERR_CANCELED') return

    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetEnrollmentCertificateError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}

export const SCHEDULED_ENROLLMENT_CERTIFICATE = 'SCHEDULED_ENROLLMENT_CERTIFICATE'
export const onScheduledEnrollmentCertificate = makeActionCreator(SCHEDULED_ENROLLMENT_CERTIFICATE)
export const onScheduledEnrollmentCertificateThunk = () => async dispatch => {
  dispatch(onScheduledEnrollmentCertificate())
}

export const GET_ENROLLMENT_CERTIFICATE_PDF = 'GET_ENROLLMENT_CERTIFICATE_PDF'
export const GET_ENROLLMENT_CERTIFICATE_PDF_ERROR = 'GET_ENROLLMENT_CERTIFICATE_PDF_ERROR'
export const GET_ENROLLMENT_CERTIFICATE_PDF_SUCCESS = 'GET_ENROLLMENT_CERTIFICATE_PDF_SUCCESS'
export const onGetEnrollmentCertificatePdf = makeActionCreator(GET_ENROLLMENT_CERTIFICATE_PDF)
export const onGetEnrollmentCertificatePdfError = makeActionCreator(GET_ENROLLMENT_CERTIFICATE_PDF_ERROR, 'payload')
export const onGetEnrollmentCertificatePdfSuccess = makeActionCreator(GET_ENROLLMENT_CERTIFICATE_PDF_SUCCESS, 'payload')

export const onGetTenderEnrollmentCertificatePdfThunk = payload => async (dispatch, getState) => {
  dispatch(onGetEnrollmentCertificatePdf())

  try {
    const { pdfDownload } = getState().enrollmentCertificate
    if (pdfDownload?.type === 'tender' && pdfDownload?.key === payload?.numAcquisition) {
      downloadFile(pdfDownload?.blob, pdfDownload?.fileName)
      return dispatch(
        onGetEnrollmentCertificatePdfSuccess({
          blob: pdfDownload?.blob,
          fileName: pdfDownload?.fileName,
          key: pdfDownload?.key,
          type: 'tender'
        })
      )
    }

    const { data, headers } = await getTenderEnrollmentCertificatePdf({
      actionType: GET_ENROLLMENT_CERTIFICATE_PDF,
      numAcquisition: payload?.numAcquisition
    })

    const blob = generateBlob(data, headers['content-type'])
    const date = formatDate(new Date(), 'yyyyMMdd_HH_mm')
    const fileName = `Certificado de habilidad_${date}.pdf`
    downloadFile(blob, fileName)

    return dispatch(
      onGetEnrollmentCertificatePdfSuccess({
        blob,
        fileName,
        key: payload?.numAcquisition,
        type: 'tender'
      })
    )
  } catch (error) {
    if (error.originalError?.code === 'ERR_CANCELED') return

    return dispatch(
      onGetEnrollmentCertificatePdfError({
        error: customizeError({
          originalError: error?.originalError,
          code: error.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}

export const onGetSellerEnrollmentCertificatePdfThunk = payload => async (dispatch, getState) => {
  dispatch(onGetEnrollmentCertificatePdf())

  try {
    const { pdfDownload } = getState().enrollmentCertificate
    if (pdfDownload?.type === 'seller' && pdfDownload?.key === payload.dni) {
      downloadFile(pdfDownload?.blob, pdfDownload?.fileName)
      return dispatch(
        onGetEnrollmentCertificatePdfSuccess({
          blob: pdfDownload?.blob,
          fileName: pdfDownload?.fileName,
          key: pdfDownload?.key,
          type: 'seller'
        })
      )
    }

    const { data, headers } = await getSellerEnrollmentCertificatePdf({
      dni: payload.userType === 'Comprador' ? payload.dni : undefined,
      isForeign: payload?.isForeign ? '1' : '0',
      actionType: GET_ENROLLMENT_CERTIFICATE_PDF
    })
    const blob = generateBlob(data, headers['content-type'])
    const date = formatDate(new Date(), 'yyyyMMdd_HH_mm')
    const fileName = `Certificado de habilidad_${date}.pdf`
    downloadFile(blob, fileName)

    return dispatch(
      onGetEnrollmentCertificatePdfSuccess({
        blob,
        fileName,
        key: payload.dni,
        type: 'seller'
      })
    )
  } catch (error) {
    if (error.originalError?.code === 'ERR_CANCELED') return

    return dispatch(
      onGetEnrollmentCertificatePdfError({
        error: customizeError({
          originalError: error?.originalError,
          code: error.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}

export const GET_FILE_SELLER_PDF_ERROR = 'GET_FILE_SELLER_PDF_ERROR'
export const GET_FILE_SELLER_PDF_SUCCESS = 'GET_FILE_SELLER_PDF_SUCCESS'
export const onGetFileSellerPdfSuccess = makeActionCreator(GET_FILE_SELLER_PDF_SUCCESS, 'payload')
export const onGetFileSellerPdfError = makeActionCreator(GET_FILE_SELLER_PDF_ERROR, 'payload')

export const onGetPDFFilePublicThunk = payload => async dispatch => {
  dispatch(onGetEnrollmentCertificatePdf())
  try {
    const { data, headers } = await getSellerFilePDFPublic({
      dni: payload.dni,
      token: payload.token
    })

    const blob = generateBlob(data, headers['content-type'])
    const date = formatDate(new Date(), 'yyyyMMdd_HH_mm')
    const fileName = `Ficha_PDF_${date}.pdf`
    downloadFile(blob, fileName)
    return dispatch(onGetFileSellerPdfSuccess())
  } catch (error) {
    if (error.originalError?.code === 'ERR_CANCELED') return

    dispatch(
      onGetFileSellerPdfError({
        error: customizeError({
          originalError: error?.originalError,
          code: error.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
    return setTimeout(
      () =>
        dispatch(
          onGetFileSellerPdfError({
            error: undefined
          })
        ),
      10000
    )
  }
}

export const onGetPDFFilePrivateThunk = payload => async dispatch => {
  dispatch(onGetEnrollmentCertificatePdf())
  try {
    const { data, headers } = await getSellerFilePDFPrivate({
      dni: payload.dni
    })

    const blob = generateBlob(data, headers['content-type'])
    const date = formatDate(new Date(), 'yyyyMMdd_HH_mm')
    const fileName = `Ficha_PDF_${date}.pdf`
    downloadFile(blob, fileName)
    return dispatch(onGetFileSellerPdfSuccess())
  } catch (error) {
    if (error.originalError?.code === 'ERR_CANCELED') return

    dispatch(
      onGetFileSellerPdfError({
        error: customizeError({
          originalError: error?.originalError,
          code: error.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
    return setTimeout(
      () =>
        dispatch(
          onGetFileSellerPdfError({
            error: undefined
          })
        ),
      10000
    )
  }
}
